<h1 *ngIf="name">{{ name }}</h1>